import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const ClearBufferConfirmationModal = ({ isOpen, onCloseClick, onClearClick }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.Loader size={60} className="text-info" />
          <div className="fs-4 pt-2">Are you sure?</div>
          <div className="fs-6 pt-2 text-center">
            Are you sure you want to clear the buffer? This action will remove all data from the
            buffer.
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button onClick={onCloseClick} className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button onClick={onClearClick} className="px-5 bg-primary border-primary">
          Clear
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ClearBufferConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onClearClick: PropTypes.func
};

export default ClearBufferConfirmationModal;
